<!-- eslint-disable-next-line vue/no-v-for-template-key -->
<template>
    <!-- eslint-disable-next-line vue/no-v-for-template-key -->
    <v-card>

        <v-dialog v-model="dgExportHeader" max-width="600px" max-height="200px" scrollable>

            <v-card>
                <v-toolbar dark color="primary">

                    <v-toolbar-title>Bilgi İhraç Ekranı</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn dark icon @click="excelAktar" v-bind="attrs" v-on="on">

                                    <v-icon>mdi-database-export</v-icon>
                                </v-btn>
                            </template>
                            <span>Excel Aktar</span>
                        </v-tooltip>
                    </v-toolbar-items>

                </v-toolbar>


                <v-data-table v-model="selectedHeader" :headers="exportHeader" :items="header" items-per-page="-1"
                    hide-default-footer="true" item-key="value" show-select class="elevation-1">

                </v-data-table>

            </v-card>
        </v-dialog>


        <v-toolbar dark color="primary">

            <v-toolbar-title> {{ result.formname }}</v-toolbar-title>

            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Arama" single-line
                hide-details></v-text-field>
            <v-toolbar-items>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn dark icon @click="dgExportHeader = true" v-bind="attrs" v-on="on">

                            <v-icon>mdi-database</v-icon>
                        </v-btn>
                    </template>
                    <span>Excel Aktar</span>
                </v-tooltip>
            </v-toolbar-items>

        </v-toolbar>
        <!-- <v-card-title class="text-h5 grey lighten-2">
        
        </v-card-title> -->

        <v-card-text>
            <v-dialog v-model="dgKolanlarıGoster" scrollable width="700">


                <v-card>
                    <v-card-title class="text-h5 grey lighten-2">
                        Form Verileri
                    </v-card-title>

                    <v-card-text>


                        <!-- <v-list subheader three-line>
                            <v-subheader> {{ result.formname }} Bilgileri</v-subheader>

                            <v-list-item v-for="item in selectedItem.columns" :key="item.ogeId">

                                <v-list-item-content>
                                    <v-list-item-title>{{ item.header }}</v-list-item-title>
                                    <v-list-item-subtitle>

                                        <div v-if="item.tur == 1">
                                            <a target="_blank" :href="`../` + itemLink"
                                                v-for="(itemLink, indexLink) in item.value.split(',')"
                                                :key="itemLink">Dosya_{{
                                                    indexLink }}</a>
                                        </div>
                                        <div v-else>
                                            {{ item.value }}
                                        </div>

                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle v-if="result.onayDurumId == 4">{{ item.reddedilmeNedeni
                                    }}</v-list-item-subtitle>
                                    <v-divider></v-divider>
                                </v-list-item-content>
                            </v-list-item>


                        </v-list> -->

                        <FormViewRun2 :actionVisible="false" :formSavedId="selectedItem.formSavedId" :edit="true">
                        </FormViewRun2>

                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-select v-model="selectedOnayDurumId" :items="onayDurums" item-text="name" item-value="id"
                            label="Onay Durumu" persistent-hint single-line></v-select>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" text @click="btnOnaylamaIslemKaydet">
                            Kaydet
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>


            <v-alert type="success" v-if="result.onaylama && result.groupName">
                <v-text-field name="name" append-outer-icon="mdi-tab-search"
                    label="Öğrenci Numarası yada Personel E-Postası ile arama yapınız" v-model="search2"
                    @click:append-outer="ara">
                </v-text-field>

                <ul class="d-flex">
                    <li class="mx-2" v-for="dataItem in result.data" :key="dataItem.name">
                        {{ dataItem.name }}
                        <table class="VTextMatrix">

                            <tr v-for="raporItem in dataItem.rapor" :key="dataItem.name + '_' + raporItem.onayDurumId">

                                <td>{{ raporItem.onayDurum }}</td>
                                <td>{{ raporItem.count }}</td>
                            </tr>
                        </table>
                    </li>
                </ul>
                <!-- <v-btn @click="ara" color="#ccc">Ara</v-btn> -->
            </v-alert>




            <!-- :show-group-by="result.onaylama" -->
            <v-data-table :headers="selectedHeader" :items="DataItems" class="elevation-1" item-key="formSavedId"
                show-group-by :search="search">
                <!-- <template v-slot:group="{ items }">
                    <tr v-for="item in items" :key="item.username">
                       
                        <td>{{ item.username }}</td>
                        <td>{{ item.date }}</td>
                        <td>{{ item.onayDurumId }}</td>
                    
                        <td v-for="col in item.columns" :key="col.ogeId">
                            <div v-if="col.tur == 1">
                                <a target="_blank" :href="`../` + itemLink"
                                    v-for="(itemLink, indexLink) in col.value.split(',')" :key="itemLink">Dosya_{{
                                    indexLink }}</a>
                            </div>
                            <div v-else>
                                {{ col.value }}
                            </div>
                        </td>
                        <td v-if="result.onaylama">
                            <div class="my-2">
                                <v-btn color="primary" fab small dark @click="btnOnaylamaIslem(item)">
                                    <v-icon>mdi-pencil</v-icon>
                                </v-btn>
                            </div>
                        </td>
                    </tr>
                </template> -->
                <!-- <template v-slot:item="{ item }">
                    <tr>
             
                        <td>{{ item.username }}</td>
                        <td>{{ item.date }}</td>
                    
                        <td v-for="col in item.columns" :key="col.ogeId">
                            <div v-if="col.tur == 1">
                                <a target="_blank" :href="`../` + itemLink"
                                    v-for="(itemLink, indexLink) in col.value.split(',')" :key="itemLink">Dosya_{{
                                    indexLink }}</a>
                            </div>
                            <div v-else>
                                {{ col.value }}
                            </div>
                        </td>
                        <td v-if="result.onaylama">
                            <div class="my-2">
                                <v-btn color="primary" fab small dark @click="btnOnaylamaIslem(item)">
                                    <v-icon>mdi-pencil</v-icon>
                                </v-btn>
                            </div>
                        </td>
                    </tr>
                </template> -->
                <template v-if="result.onaylama"
                    v-slot:group.header="{ items, group, isOpen, toggle, headers, remove }">

                    <td :colspan="headers.length - 3" class="grey lighten-3">
                        <v-btn icon small @click="toggle">
                            <v-icon>{{ isOpen ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon>
                        </v-btn>
                        <strong>{{ group }}</strong>

                        <v-btn v-if="isOpen" icon small @click="remove">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>


                        <span class="ml-2">({{ items.length }} kayıt) </span><br>
                        <span class="mx-2">Onaylanan: {{items.filter(m => m.onayDurumId == 3).length}},</span>
                        <span>Reddedilen: {{items.filter(m => m.onayDurumId == 4).length}},</span>
                        <span class="mx-2">Düz. Reddedilen: {{items.filter(m => m.onayDurumId == 5).length}},</span>
                        <span>Red Sonrası Düzeltme: {{items.filter(m => m.onayDurumId == 2).length}},</span>
                        <span>Onay Bekleyen: {{items.filter(m => m.onayDurumId == 1).length}}</span>
                    </td>

                </template>
                <template v-if="!Admin" v-slot:item.actions="{ item }">

                    <v-btn color="primary" fab small dark @click="btnOnaylamaIslem(item)">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                </template>
                                <template v-slot:item.resim="{ item }">
 <v-avatar size="64" class="profile" tile>
                      <v-img
  lazy-src="/amasya_logo.png"

  :src="item.resim"
></v-img>
    </v-avatar>

                </template>

                <template v-for="(file) in files" v-slot:[`item.${file.ogeId}`]="{ value }">
                    <div>
                        <div class="my-1" v-for="(itemLink, indexLink) in value.split(',')" :key="indexLink">
                            <a target="_blank" :href="`../` + itemLink">Dosya_{{ indexLink }}</a>
                        </div>
                    </div>




                </template>
                <template v-for="(text) in textMatrixs" v-slot:[`item.${text.ogeId}`]="{ value }">

                    <table class="VTextMatrix">

                        <tr>
                            <th v-for="hea in JSON.parse(text.json).columns" :key="hea.id"> {{ hea.name }}</th>
                        </tr>
                        <tr v-for="(row,rowIndex) in value" :key="row.id+`_`+rowIndex">

                            <td v-for="(column,columnIndex) in row.values" :key="column+`_`+rowIndex+`_`+columnIndex ">{{ column }}</td>
                        </tr>
                    </table>





                </template>



            </v-data-table>

            <!-- <v-simple-table fixed-header height="300px" ref="sdfsfsd" class="clsForm"
                no-data-text="Denetleyebileceğiniz başvuru bulunmamaktadır. ">
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th>Kullanıcı</th>
                            <th>Başvuru Tarihi</th>
                            <th class="text-left" v-for="(item) in header" :key="item.ogeId">
                                {{ item.header }}
                            </th>
                            <th v-if="result.onaylama"></th>
                        </tr>
                    </thead>
                    <tbody>

                     
                        <tr v-for="item in filteredList" :key="item.formSavedId">
                            <td>{{ item.username }} </td>
                            <td>{{ item.date }}</td>
                            <td v-for="itemrow in item.columns" :key="itemrow.ogeId">
                                <div v-if="itemrow.tur == 1">
                                    <a target="_blank" :href="`../` + itemLink"
                                        v-for="(itemLink, indexLink) in itemrow.value.split(',')"
                                        :key="itemLink">Dosya_{{ indexLink }}</a>
                                </div>
                                <div v-else>
                                    {{ itemrow.value }}
                                </div>


                            </td>


                            <td v-if="result.onaylama">
                                <div class="my-2">
                                    <v-btn color="primary" fab small dark @click="btnOnaylamaIslem(item)">
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="result.rows.length == 0">
                            <td colspan="4" class="text-center">Denetlebiliecek başvuru bulunamadı.</td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table> -->




            <div class="v-data-table theme--light">
                <div class="v-data-table__wrapper">
                    <!-- <table id="tblFormData"   >

                        <thead>
                            <tr :key="index">
                                <th class="text-left" v-for="(item) in header" :key="item.ogeId">
                                    {{ item.header }}
                                </th>
                                <th v-if="result.onaylama"></th>
                            </tr>
                        </thead>
                        <tbody>
                          
                            <tr v-for="item in result.rows" :key="item.formSavedId">
                                <td v-for="itemrow in item.columns" :key="itemrow.ogeId">{{ itemrow.value }}</td>


                                <td v-if="result.onaylama">
                                    <div class="my-2">
                                        <v-btn color="primary" fab small dark
                                            @click="btnOnaylamaIslem(item.formSavedId)">
                                            <v-icon>mdi-pencil</v-icon>
                                        </v-btn>
                                    </div>
                                </td>
                            </tr>
                        </tbody>

                    </table> -->
                </div>
            </div>

        </v-card-text>

        <v-divider></v-divider>

        <!-- <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialog = false">
                I accept
            </v-btn>
        </v-card-actions> -->
    </v-card>

</template>
<script>
//import router from '@/router';
import { tableToExcel } from '@/plugins/custom';
import OnayDurumEnum, { ValueTurEnum } from '@/plugins/Enum'
import router from '@/router/index';
import FormService from '@/services/FormService';
import OnayDurumService from '@/services/OnayDurumService';
import FormViewRun2 from '@/components/FormViewRun2.vue';



export default {

    name: "KullaniciFormData",
    components: { FormViewRun2 },
    props: {
        Admin: {
            // default: '{"title":"","description":""}',
            default() {
                return false;
            },
            type: Boolean
        },


    },
    data() {
        return {
            dgExportHeader: false,
            files: [],
            textMatrixs: [],
            selectedHeader: [],
            exportHeader: [
                {
                    text: 'Alan Adı', value: 'text'
                },


            ],
            headers: [
                { text: "Resim", value: "resim" },
                { text: "Kullanıcı", value: "username" },
                { text: "Kullanıcı", value: "username2" },
                { text: "Tarih", value: "date" },
                // { text: "Onay Durum ID", value: "onayDurumId" },
                { text: "Tek Satırlı Metin", value: "col1" },
                { text: "Sayılar", value: "col2" },
                { text: "Tarih", value: "col3" },
                { text: "Onaylama", value: "col4" },
         
            ],
            search: "",
            search2: "",
            selectedItem: [],
            dgKolanlarıGoster: false,
            onayDurums: [],
            selectedOnayDurumId: null,

            result: {
                onaylama: false,
                formname: "",
                rows: [

                ]
            },
            values: [],
        }
    },
    created() {
        this.dataBind();
    },
    methods: {

        btnOnaylamaIslem(item) {
            this.selectedItem = item;
            this.dgKolanlarıGoster = true;
            this.selectedOnayDurumId = this.selectedItem.onayDurumId;
            //             console.log("btnOnaylamaIslem:",item);


            // alert("vxcvxcv:" + formSavedId);
        },

        btnOnaylamaIslemKaydet() {

            console.log("this.SElectedItem:", this.selectedItem);
            if (this.selectedOnayDurumId) {
                let reddedilmeNedeni = "";
                //if (this.selectedOnayDurumId==4 ) {
                if ([4, 5].includes(this.selectedOnayDurumId)) {
                    let value = prompt('Reddedilme Nedeni Giriniz',);
                   // console.log("Prompt:", value);
                    if (value == null) {
                        return false;
                    }
                    else {
                        reddedilmeNedeni = value;
                    }

                }

                //this.$toast.warning("Onay Durumu boş bırakılamaz."+value)
                FormService.onaylama(this.selectedItem.formSavedId, { onayDurumId: this.selectedOnayDurumId, onayDurumSebeb: reddedilmeNedeni }).then((result) => {
                    this.dataBind();
                    this.$toast.success("İşleminiz başarılı bir şekilde gerçekleştirilmiştir.");
                    this.dgKolanlarıGoster = false;
                }).catch((err) => {

                });
            }
            else {
                this.$toast.warning("Onay Durumu boş bırakılamaz.")
            }

        },
        excelAktar() {
            // console.log("object,", document.getElementById("tblFormDataHeader").parentElement);
            let outTable = document.getElementsByClassName("v-data-table__wrapper");
            console.log("outTable", outTable);
            let table = outTable[0].querySelector("table");

            // tableToExcel("tblFormData", this.result.formname);
            tableToExcel(table, this.result.formname);
        },
        ara() {
           // console.log("this.search2,", this.search2);
            FormService.listFormResultDataItemsByNo(this.$route.params.id, this.search2).then((result) => {
               // console.log("result,", result.data);
                this.result = result.data;
                this.files = this.result.rows[0].columns.filter(m => m.tur == 1);
                this.textMatrixs = this.result.rows[0].columns.filter(m => m.tur == 5);
                this.selectedHeader = this.header;
                // console.log("this.files", this.files);
            }).catch((err) => {

            });
        },
        dataBind() {

            // console.log("this.dataBind,", this.$route.params);
            FormService.listFormResultDataItems(this.$route.params.id).then((result) => {
               // console.log("result,", result.data);
                this.result = result.data;
                this.files = this.result.rows[0].columns.filter(m => m.tur == 1);
                this.textMatrixs = this.result.rows[0].columns.filter(m => m.tur == 5);
                this.selectedHeader = this.header;
               //  console.log("this.selectedHeader", this.selectedHeader);
            }).catch((err) => {

            });
            OnayDurumService.listOnayDurums().then((result) => {
                this.onayDurums = result.data;
            }).catch((err) => {

            });


        },
        // editItem(v) {
        //   router.push({ name: 'formgosterim', params: { id: v.id } })
        // },
        // formTasarimGonder(v) {
        //   console.log("formTasarimGonder");
        //   router.push({ name: 'formtasarimi', params: { id: v.id } })
        // }
    }, computed: {


        filteredList() {
            let sea = this.search;
           // console.log("object", this.result);
            if (sea) {
                let filterValues = this.result.rows.filter(m => m.username.includes(sea) || m.date.includes(sea) || m.columns.some(x => x.value.includes(sea)));
                //let filterValues= this.result.rows.filter(m=>m.username.includes(sea) || m.date.includes(sea) );
                return filterValues;
            }
            else {
                console.log("Result.rows=", this.result.rows);
                return this.result.rows;
            }

        },
        header() {


            if (this.result.rows.length > 0) {
                let cListe = []
               // console.log("ResultRows:", this.result.rows);
                this.result.rows.forEach(element => {
                    element.columns.forEach(element2 => {
                       // let arananEleman = cListe.find(m => m.header == element2.header)
                        let arananEleman = cListe.find(m => m.ogeId == element2.ogeId)
                        if (arananEleman == undefined) {
                            cListe.push(element2);
                        }
                    });
                });

                //let columnData = this.result.rows[0].columns.map(x => { return { text: x.header, value: x.ogeId, sortable: true } });
                let columnData = cListe.map(x => { return { text: x.header, value: x.ogeId, sortable: true } });
                let liste = [
                       { text: "Resim", value: "resim", sortable: false,group:false },
                    { text: "Kullanıcı", value: "username", sortable: true },
                    { text: "K.Ad Soyad", value: "username2", sortable: true },
                    { text: "Tarih", value: "date" },

                    ...columnData,

                ]
                if (this.result.onaylama) {
                    liste.push({ text: "Onaylama", value: "onayName" });
                    liste.push({ text: "Onaylayan", value: "onaylayanName" });
                    if (!this.Admin) {
                        liste.push({ text: "Onay", value: "actions" });
                    }


                }

                // console.log("object", this.result.rows[0].columns);
                // console.log("Liste", liste);
                //return this.result.rows[0].columns;
                return liste;
            }
            return [];

        },
        DataItems() {
           // console.log("DataItems:", this.result);
            if (this.result.rows.length > 0) {
                let data = this.result.rows.map(element => {
                    let temp = {
                       resim: element.resim,
                       onayDurumId: element.onayDurumId, username: element.username, username2: element.username2, formSavedId: element.formSavedId, date: element.date, reddedilmeNedeni: element.reddedilmeNedeni

                    };
                    if (this.result.onaylama) {
                        temp["onayName"] = element.onayName;
                        temp["onaylayanName"] = element.onaylayanName;
                    }


                    element.columns.forEach(element2 => {
                        // console.log("Column:", element2);
                        if (element2.tur == ValueTurEnum.MatrixText)//Text Matrix in value değeri json şeklinde fakar gösterirken tablo şeklinde gösteriliyor
                        {
                            let lsRows = JSON.parse(element2.value);
                            //temp[element2.ogeId] = "<table><tr><th>fghfghg</th> </tr></table>";
                            temp[element2.ogeId] = lsRows;
                        }
                        else {
                            temp[element2.ogeId] = element2.value;
                        }



                    });
                    // console.log("Temp:", temp);
                    return temp;
                });
                return data;

            }
            return [];

        }

    },
}
</script>
<style scoped>
.myTable tbody {
    height: calc(100vh - 250px);
    overflow-y: auto;
    display: block;
}

.myTable thead {
    display: block;
}

table.VTextMatrix {
    border-collapse: collapse;
}

table.VTextMatrix tr,
th,
td {
    border: 1px solid gray;

    padding: 2px;
}
</style>